import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
const useCreditNudgeStore = create(
  persist(
    (set, get) => ({
      data: {},
      setCreditNudgeData: data => {
        set({
          data: {
            ...get().formData,
            ...data
          }
        });
      },
      reset: () => {
        set({
          data: {}
        });
      }
    }),
    {
      name: "useCreditNudgeStore",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useCreditNudgeStore;
